import React, { useState } from 'react';
import TokenTable from './TokenTable';
import CounterPanel from './CounterPanel';

const MarketingPage: React.FC = () => {
  const [sidebarWidth, setSidebarWidth] = useState(25); // Default 25% width
  const [isDragging, setIsDragging] = useState(false);
  
  // Handle mouse down on the resizer
  const handleMouseDown = (e: React.MouseEvent) => {
    e.preventDefault();
    setIsDragging(true);
    
    // Add event listeners for mouse move and mouse up
    document.addEventListener('mousemove', handleMouseMove);
    document.addEventListener('mouseup', handleMouseUp);
  };
  
  // Handle mouse move while dragging
  const handleMouseMove = (e: MouseEvent) => {
    if (!isDragging) return;
    
    // Calculate new width based on mouse position
    const containerWidth = document.getElementById('main-container')?.clientWidth || 1000;
    const newWidth = (e.clientX / containerWidth) * 100;
    
    // Limit width between 15% and 40%
    const limitedWidth = Math.max(15, Math.min(40, newWidth));
    setSidebarWidth(limitedWidth);
  };
  
  // Handle mouse up to stop dragging
  const handleMouseUp = () => {
    setIsDragging(false);
    
    // Remove event listeners
    document.removeEventListener('mousemove', handleMouseMove);
    document.removeEventListener('mouseup', handleMouseUp);
  };
  
  return (
    <div className="min-h-screen bg-gray-100 pt-20">
      <div className="max-w-full mx-auto py-4 sm:px-6 lg:px-8">
        <div id="main-container" className="max-w-full mx-auto sm:px-6 lg:px-8">
          <div className="flex flex-col md:flex-row relative">
            <div 
              className="w-full md:w-auto flex-grow pr-0 md:pr-4 mb-6 md:mb-0"
              style={{ width: `calc(100% - ${sidebarWidth}%)` }}
            >
              <TokenTable />
            </div>
            
            {/* Resizer */}
            <div 
              className="hidden md:block absolute top-0 bottom-0 w-1 bg-gray-300 hover:bg-indigo-500 cursor-col-resize z-10"
              style={{ left: `calc(100% - ${sidebarWidth}% - 0.5rem)` }}
              onMouseDown={handleMouseDown}
            ></div>
            
            <div 
              className="w-full md:w-auto flex-shrink-0"
              style={{ width: `${sidebarWidth}%` }}
            >
              <CounterPanel />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MarketingPage; 